import React from 'react';

// Components
import { WpButton } from 'Wpds/components/button';

// Styles
import './JoinableOrganization.scss';

type Props = {
  organization: {
    slug: string;
    name: string;
    usersCount: number;
    founderIdentifier: string;
  };
  onJoinClick: Function;
  isJoinDisabled: boolean;
};

function JoinableOrganization({
  organization: { name, founderIdentifier, slug, usersCount },
  onJoinClick,
  isJoinDisabled,
}: Props) {
  const memberLabel = `(${usersCount} ${usersCount === 1 ? 'member' : 'members'})`;

  const handleButtonClick = () => onJoinClick(slug);

  return (
    <div className="joinable-organization d-flex justify-content-between align-items-center border rounded py-2 px-3">
      <div className="joinable-organization-name d-flex flex-column">
        <div className="mb-1">
          {name}
          &nbsp;
          {memberLabel}
        </div>
        <div className="joinable-organization-founder">
          Created by&nbsp;
          {founderIdentifier}
        </div>
      </div>
      <WpButton size="sm" onClick={handleButtonClick} disabled={isJoinDisabled}>
        Join
      </WpButton>
    </div>
  );
}

export default JoinableOrganization;
